import React, { useState } from "react";
import { MLBPlayerSearch } from "../mlb-player-search";
import "./player-report-config.css";

const YEARS = [2021, 2022, 2023, 2024, 2025, 2026];
const DEFAULT_YEAR = 2026;

export const PlayerReportConfig = (props) => {
  const { onExport } = props;
  const [year, setYear] = useState(DEFAULT_YEAR);
  const [player, setPlayer] = useState(null);
  const [exporting, setExporting] = useState(false);

  const canExport = !!player && !exporting;

  const handleExport = async () => {
    if (!player) return;
    setExporting(true);
    try {
      await onExport({ player, year });
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="prc-root">
      <div>
        <div className="prc-section-label">Player</div>
        <MLBPlayerSearch selected={player} onSelect={setPlayer} />
      </div>

      <div>
        <div className="prc-section-label">Year</div>
        <select
          className="prc-year-select"
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
        >
          {YEARS.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      <button
        className={`prc-export-btn${canExport ? " prc-export-btn--ready" : " prc-export-btn--disabled"}`}
        onClick={handleExport}
        disabled={!canExport}
      >
        {exporting ? "Generating" : "Export PDF"}
      </button>
    </div>
  );
};
